<template>
  <div
    class="container widget-management"
    ref="container"
  >
    <div class="toolbar-wrapper cf">
      <el-button
        type="iconButton"
        icon="h-icon-add"
        :disabled="widgetType==='todo'"
        @click="addWidget"
      >{{
        $t("common.addBtn_text")
        }}</el-button>
      <widget-filter
        style="float: right;"
        v-model="widgetType"
      ></widget-filter>
    </div>
    <div class="list-wrapper">
      <el-scrollbar
        class="auto-height-scrollbar"
        v-if="filterWidgets && filterWidgets.length > 0"
      >
        <widget-item
          v-for="widget in filterWidgets"
          :key="widget.id"
          :data="widget"
          model="edit"
          @preview-widget="previewWidget"
          @remove-widget="removeWidget"
          @edit-widget="editWidget"
        >
        </widget-item>
      </el-scrollbar>
      <div
        class="no-data"
        v-else
      >
        <span>{{ $t("common.no_widgets_pls_add") }}</span>
      </div>
    </div>
    <el-dialog
      :visible.sync="dialogVisible"
      :title="dialogTitle"
      custom-class="no-padding auto-height"
      :area="[682, 700]"
    >
      <widget-info
        v-if="dialogVisible"
        :addFlag="addFlag"
        :widgetType="widgetType"
        ref="widgetInfo"
      ></widget-info>
      <span slot="footer">
        <el-button
          type="primary"
          @click="finishOperate"
        >{{
          $t("common.confirmBtn_text")
          }}</el-button>
        <el-button @click="cancelOperate">{{
          $t("common.cancelBtn_text")
          }}</el-button>
      </span>
    </el-dialog>
    <widget-preview
      :visible.sync="showPreview"
      :data="filterWidgets"
      :index.sync="previewIndex"
    ></widget-preview>
  </div>
</template>

<script>
import widgetFilter from 'components/widget-filter/widget-filter'
import widgetPreview from 'components/widget-preview/widget-preview'
import widgetInfo from './widget-info.vue'
import widgetItem from 'components/widget-item/widget-item'
import Api from 'api/api'
import { ErrorHandleMixin, LoadingMixin } from 'utils/mixin'
export default {
  name: 'widget-management',
  data () {
    return {
      widgetType: 'all',
      widgets: [],
      dialogVisible: false,
      addFlag: true,
      addDialogTitle: this.$t('management.widget.add_dialog_title'),
      editDialogTitle: this.$t('management.widget.edit_dialog_title'),
      showPreview: false,
      previewIndex: 0
    }
  },
  methods: {
    _getList () {
      let _loadingInstance = this._getLoading()
      Api.widget
        .list()
        .then(res => {
          this.widgets = res.data.list
          _loadingInstance.close()
        })
        .catch(() => {
          _loadingInstance.close()
        })
    },
    _removeWidget (id) {
      let _loadingInstance = this._getLoading()
      Api.widget
        .remove({
          widgetIds: id
        })
        .then(res => {
          _loadingInstance.close()
          this.$message.success(this.$t('management.widget.delete_success'))
          this._getList()
        })
        .catch(() => {
          _loadingInstance.close()
        })
    },
    _addWidget (widget) {
      widget['isBanner'] = 0
      let _loadingInstance = this._getLoading()
      Api.widget
        .add({
          ...widget
        })
        .then(res => {
          _loadingInstance.close()
          this.$message.success(this.$t('management.widget.add_success'))
          this._getList()
          this.dialogVisible = false
        })
        .catch(() => {
          _loadingInstance.close()
        })
    },
    _editWidget (widget) {
      let _loadingInstance = this._getLoading()
      Api.widget
        .edit({
          ...widget
        })
        .then(res => {
          _loadingInstance.close()
          this.$message.success(this.$t('management.widget.edit_success'))
          this._getList()
          this.dialogVisible = false
        })
        .catch(() => {
          _loadingInstance.close()
        })
    },
    removeWidget (id) {
      this.$confirm(this.$t('management.widget.delete_confirm'), {
        confirmButtonText: this.$t('common.confirmBtn_text'),
        cancelButtonText: this.$t('common.cancelBtn_text'),
        type: 'question'
      })
        .then(() => {
          this._removeWidget(id)
        })
        .catch(() => { })
    },
    addWidget () {
      this.dialogVisible = true
      this.addFlag = true
    },
    editWidget (widget) {
      this.dialogVisible = true
      this.addFlag = false
      this.$nextTick(() => {
        this.$refs.widgetInfo.fillBack(widget)
      })
    },
    finishOperate () {
      let _result = this.$refs.widgetInfo.getResult()
      if (_result === false) {
        return
      }
      if (_result.id) {
        this._editWidget(_result)
      } else {
        this._addWidget(_result)
      }
    },
    cancelOperate () {
      this.dialogVisible = false
    },
    previewWidget (widget) {
      this.filterWidgets.forEach((item, index) => {
        if (item.id === widget.id) {
          this.previewIndex = index
        }
      })
      this.showPreview = true
    }
  },
  computed: {
    filterWidgets () {
      return this.widgets.filter(item => {
        if (this.widgetType === 'all') return item
        else return item.type === this.widgetType
      })
    },
    dialogTitle () {
      return this.addFlag ? this.addDialogTitle : this.editDialogTitle
    }
  },
  mounted () {
    this._getList()
  },
  mixins: [ErrorHandleMixin, LoadingMixin],
  components: {
    widgetFilter,
    widgetInfo,
    widgetItem,
    widgetPreview
  }
}
</script>

<style scoped lang="less" rel="stylesheet/less">
.widget-management.container {
  width: 100%;
  height: 100%;
  position: relative;
  box-sizing: border-box;
  padding: 18px 24px;
  .toolbar-wrapper {
    height: 32px;
  }
  .list-wrapper {
    position: absolute;
    top: 72px;
    left: 17px;
    right: 17px;
    bottom: 10px;
    margin: 0 -6px;
    .no-data {
      position: absolute;
      left: 50%;
      margin-left: -150px;
      top: 50%;
      margin-top: -180px;
      width: 300px;
      height: 300px;
      background-image: url("../../../assets/images/no_widgets.png");
      background-position: center;
      background-repeat: no-repeat;
      span {
        position: absolute;
        bottom: 50px;
        display: block;
        width: 100%;
        height: 30px;
        line-height: 30px;
        font-size: 12px;
        text-align: center;
        color: #999;
      }
    }
  }
}
</style>
